export default __webpack_public_path__ + "b618be2a1b43c61f4521a3ee904ab5a3.jpg";